export const SEARCH_PARAM = {
  GROUP: 'group',
  TYPE: 'type',
  COUNTRY: 'country',
  SEARCH: 'search',
  OWNER: 'owner',
} as const
